export default __webpack_public_path__ + "static/media/dragon.46bd00c7.jpg";